import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { BLOG_POSTS, formatBlogDate } from "@/data/blogPosts";

export default function Blog() {
  useEffect(() => {
    document.title = "Blog · Wissen rund um Pflege & Weiterbildung | Dickies-Campus";
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = "Der Dickies-Campus Blog: verständliche Artikel zu Pflege-Weiterbildungen, Einstieg ohne Berufserfahrung, Förderung und mehr.";
    window.scrollTo(0, 0);
  }, []);

  const posts = [...BLOG_POSTS].sort((a, b) => (a.datePublished < b.datePublished ? 1 : -1));

  return (
    <div className="min-h-screen bg-cream-50">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24" data-testid="blog-overview-page">
        <span className="eyebrow">Blog</span>
        <h1 className="mt-3 font-heading text-4xl md:text-5xl font-semibold text-sand-800 tracking-tight">
          Wissen rund um Pflege & Weiterbildung
        </h1>
        <p className="mt-4 text-sand-700 text-[15px] leading-relaxed">
          Verständliche Artikel aus dem Dickies-Campus — zu Einstieg, Weiterbildung und Förderung in der Pflege.
        </p>

        <div className="mt-12 space-y-6">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-list-item-${post.slug}`}
              className="block rounded-2xl border border-sand-800/10 bg-white/70 p-6 sm:p-8 transition-all duration-300 hover:border-terra/50 hover:-translate-y-0.5"
            >
              <div className="text-xs uppercase tracking-widest text-terra font-bold">
                {formatBlogDate(post.datePublished)}
              </div>
              <h2 className="mt-2 font-heading text-xl md:text-2xl font-semibold text-sand-800 normal-case">
                {post.title}
              </h2>
              <p className="mt-3 text-sand-700 text-[15px] leading-relaxed line-clamp-2">
                {post.teaser}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-terra">
                Weiterlesen <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
